export const ENV = {
  names: {
    development: 'development',
    staging: 'staging',
    production: 'production',
  },
};
